import { useIsActivityAvailable } from 'src/modules/checkout/composables/activity-availability/IsActivityAvailable'
import { computed, toValue } from 'vue'

export function useAvailableActivities (activities = []) {
  const { isActivityAvailable } = useIsActivityAvailable()

  function computeAvailableActivities (activities) {
    return _.filter(toValue(activities), activity => isActivityAvailable(activity))
  }

  const availableActivities = computed(() => computeAvailableActivities(computed(() => activities)))

  return {
    computeAvailableActivities,
    availableActivities
  }
}
